// Modules
import { useCallback } from 'react'
// Application
import { useRedirectTo } from 'hooks'

export const useCampaigns = () => {
    const { redirectTo } = useRedirectTo()

    const changeCampaingSessionStorage = useCallback(() => {
        const campaingKey = '@LiviaAuth:Campaigns'
        if (redirectTo) {
            sessionStorage.setItem(campaingKey, redirectTo)
        } else {
            sessionStorage.removeItem(campaingKey)
        }
    }, [redirectTo])

    return {
        redirectTo,
        changeCampaingSessionStorage,
    }
}
